


























































































import Vue from 'vue';
import Loader from '@/components/util/Loader.vue';
import ItemCard from '@/old/items/ItemCard.vue';
import UiString from '@/components/uistring/UiString.vue';
import CashShopEntryCard from './CashShopEntryCard.vue';
import CashShopProvider from '@/api/CashShopProvider';
import ICashShopEntry, { CashCommodityType, ICashShopTab } from '@/models/items/ICashShop';
import { categoryToTabNum } from '@/util/cashShop';

interface IData {
    loading: boolean;
    entry: ICashShopEntry | null;
    packageContents: ICashShopEntry[];
    variants: ICashShopEntry[];
    error: boolean;
}

export default Vue.extend({
    components: {
        Loader,
        ItemCard,
        UiString,
        CashShopEntryCard,
    },
    props: {
        sn: {
            type: Number,
            required: true,
        },
        tabs: {
            type: Array as () => ICashShopTab[],
            default: () => [],
        },
    },
    data(): IData {
        return {
            loading: true,
            entry: null,
            packageContents: [],
            variants: [],
            error: false,
        };
    },
    computed: {
        techMode(): boolean {
            return this.$store.state.techMode;
        },
        origin(): string {
            if (!this.entry) {
                return '';
            }

            const tabNum = categoryToTabNum(this.entry.category, this.entry.subCategory, this.tabs);
            if (tabNum === null) {
                return '';
            }

            const tab = this.tabs.find((t) => t.mtNum === tabNum);
            if (!tab) {
                return '';
            }

            const sub = tab.subTabs.find((s) => s.stNum === this.entry!.subCategory);
            return sub ? `${tab.name} › ${sub.name}` : tab.name;
        },
    },
    created() {
        this.load();
    },
    watch: {
        sn() {
            this.load();
        },
        '$store.state.regionCode'() {
            this.load();
        },
    },
    methods: {
        async load() {
            this.loading = true;
            this.entry = null;
            this.packageContents = [];
            this.variants = [];
            this.error = false;
            try {
                const entry = await CashShopProvider.getEntry(this.sn);
                this.entry = entry;
                if (entry) {
                    const isPackage = entry.type === CashCommodityType.Package
                        || entry.type === CashCommodityType.DolisPackage;
                    const [pkg, variants] = await Promise.all([
                        isPackage
                            ? CashShopProvider.getPackageMemberSns(entry.sn).then((sns) => CashShopProvider.getEntriesBySns(sns))
                            : Promise.resolve([] as ICashShopEntry[]),
                        CashShopProvider.getEntriesBySns(entry.linkSns),
                    ]);
                    this.packageContents = pkg;
                    this.variants = variants;
                }
            } catch {
                if (!this.entry) {
                    this.error = true;
                }
            } finally {
                this.loading = false;
            }
        },
    },
});
